module.exports = __webpack_public_path__ + "img/yl3023.477cb53a.png";